import { shopPrefix } from '../../../config';
import { AggregationResponseOut } from '../../../store/api';
import { http } from '../../axios';
import { FetchAggregationsOptions } from '../../listContent/fetchAggregations';
import { AgeCategory } from '../../../../models/AgeCategory';

type Options = FetchAggregationsOptions & {
    readonly ageCategory?: string;
    readonly loanFormat?: string;
};

const url = `${shopPrefix}/v2/collection/newly_added/:kind`;

export const fetchCollectionNewlyAddedAggregations = (options: Options): Promise<AggregationResponseOut> => {
    return http
        .post<AggregationResponseOut>(url, options.filters, {
            signal: options.signal,
            pathParams: {
                kind: 'aggregation'
            },
            params: {
                ageCategory: options.ageCategory === AgeCategory.ALL_AGES ? undefined : options.ageCategory,
                loanFormat: options.loanFormat
            }
        })
        .then(response => response.data);
};
